export var CustomerAuthDataType;
(function (CustomerAuthDataType) {
    CustomerAuthDataType["Clue"] = "clue";
    CustomerAuthDataType["Company"] = "company";
    CustomerAuthDataType["Opportunity"] = "opportunity";
    CustomerAuthDataType["OpenSea"] = "open_sea";
    CustomerAuthDataType["RegularCustomer"] = "regular_customer";
    CustomerAuthDataType["CustomerOpenSea"] = "customer_open_sea";
    CustomerAuthDataType["Address"] = "address";
})(CustomerAuthDataType || (CustomerAuthDataType = {}));
export const CustomerEmailListCondition = CustomerAuthDataType;
export const CustomerAuthTypeMap = {
    [CustomerAuthDataType.OpenSea]: '线索公海',
    [CustomerAuthDataType.Clue]: '线索私海',
    [CustomerAuthDataType.Company]: '客户',
    [CustomerAuthDataType.Opportunity]: '商机',
    [CustomerAuthDataType.RegularCustomer]: '定制推荐',
    [CustomerAuthDataType.CustomerOpenSea]: '客户公海',
    [CustomerAuthDataType.Address]: '营销联系人',
};
export const CustomerAuthGrantStateMap = {
    0: '待审批',
    1: '已通过',
    2: '已驳回',
};
export var CustomerEmailItemHideState;
(function (CustomerEmailItemHideState) {
    CustomerEmailItemHideState["NoNeedAuth"] = "NO_NEED_AUTH";
    CustomerEmailItemHideState["NeedAuth"] = "NEED_AUTH";
    CustomerEmailItemHideState["InAuth"] = "AUTHING";
})(CustomerEmailItemHideState || (CustomerEmailItemHideState = {}));
